var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground9D63Cb4A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1062 -936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458,707s-61.38-58.17-19-95-40.421-186.661,75-303,447-86,160,412",
    transform: "translate(-1278.634 929.441)",
    fill: "#34a853",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.9,361.753C736.223,342.4,645.8,218.318,593.337,308.13S251.068,223,538.068,721",
    transform: "translate(-1548.634 929.441)",
    fill: "none",
    stroke: "#34a853",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-731.014,1641.824s-59.143-202.665,70.972-344.609c0-1.577-92.461,133.75-45.935,346.666",
    fill: "#fbbc05",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-720.4,1514.99s16.761-68.86,101.249-87.083c-6.35,4.694-58.534,21.812-101.249,120.1",
    fill: "#d4bd2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-619.154,1514.99s-16.761-68.86-101.249-87.083c6.35,4.694,58.534,21.812,101.249,120.1",
    transform: "translate(-83 146)",
    fill: "#d4bd2d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1646.428 246.004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.068,707s61.38-58.17,19-95,40.421-186.661-75-303-447-86-160,412",
    transform: "translate(-424.082 -252.563)",
    fill: "#34a853",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.428,326.388c-11.676-19.354-127.7-37.644-180.161,52.168S251.068,223,538.068,721",
    transform: "translate(-700.976 -252.563)",
    fill: "none",
    stroke: "#34a853",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-673.453,1641.824s59.143-202.665-70.972-344.609c0-1.577,92.461,133.75,45.935,346.666",
    transform: "translate(913.819 -1182.004)",
    fill: "#fbbc05",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-619.154,1514.99s-16.761-68.86-101.249-87.083c6.35,4.694,58.534,21.812,101.249,120.1",
    transform: "translate(848.91 -1182.004)",
    fill: "#d4bd2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-720.4,1514.99s16.761-68.86,101.249-87.083c-6.35,4.694-58.534,21.812-101.249,120.1",
    transform: "translate(931.91 -1036.004)",
    fill: "#d4bd2d"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1921,
    height: 224,
    transform: "translate(-1 697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.919 4.296)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.081 802.704)",
    fill: "#fff",
    stroke: "#e8e8e8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.081 805.704)",
    fill: "#fff",
    stroke: "#e8e8e8",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 13.5,
    height: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(267.081 805.704)",
    fill: "#fff",
    stroke: "#e8e8e8",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 12.5,
    height: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251.619 807.413)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.462 0.291)",
    fill: "#fff",
    stroke: "#e8e8e8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.462 8.292)",
    fill: "#fff",
    stroke: "#e8e8e8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.462 5.291)",
    fill: "#fff",
    stroke: "#e8e8e8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.462 8.292)",
    fill: "#fff",
    stroke: "#e8e8e8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.462 5.291)",
    fill: "#fff",
    stroke: "#e8e8e8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-2115.643,842.906V853.4h4.838v-10.49",
    transform: "translate(2387.012 -34.568)",
    fill: "#fff",
    stroke: "#e8e8e8",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1921,
    height: 159,
    transform: "translate(-1 921)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 386,
    height: 701,
    transform: "translate(-26)",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    width: 398,
    height: 701,
    transform: "translate(1534)",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1105,
    height: 701,
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(262.633 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 701.164,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 701.164,
    transform: "translate(289.367 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 701.164,
    transform: "translate(578.734 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 701,
    transform: "translate(360)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 701,
    transform: "translate(1496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87,0c65.729,0,87,7.611,87,17S135.049,34,87,34C8.416,34-37.863,26.389-37.863,17S21.271,0,87,0Z",
    transform: "translate(1427 941)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1383 648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1045.2,750.5l12.418-8.5,7.713,11.522L1029.48,897.55a3.288,3.288,0,0,1-4.231,2.326h0a3.288,3.288,0,0,1-2.211-3.614Z",
    transform: "translate(-995.334 -595.525)",
    fill: "#1b71c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.131,750.5,927.713,742,920,753.522,955.854,897.55a3.288,3.288,0,0,0,4.231,2.326h0a3.288,3.288,0,0,0,2.211-3.614Z",
    transform: "translate(-789.334 -595.525)",
    fill: "#1b71c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.754,750.5,911.336,742l-7.713,11.522L956.3,911.874a3.293,3.293,0,0,0,4.165,2.084h0a3.292,3.292,0,0,0,2.158-3.9Z",
    transform: "translate(-773.336 -595.525)",
    fill: "#509af7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.958,750.5l12.418-8.5,7.713,11.522-52.673,158.352a3.292,3.292,0,0,1-4.165,2.084h0a3.29,3.29,0,0,1-2.157-3.9Z",
    transform: "translate(-1012.089 -595.525)",
    fill: "#509af7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927,728s32-40,50-128c9-9,12,8,12,8l2,96-25,35Z",
    transform: "translate(-825 -595.525)",
    fill: "#e34730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.872,726S1029.127,710,951,733l125.872,9Z",
    transform: "translate(-940.872 -595.525)",
    fill: "#fdc500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.628,596c5-8,23,87-30,137h-125s14,27,141,20C1129.628,733,1088.628,606,1049.628,596Z",
    transform: "translate(-894.628 -595.525)",
    fill: "#f15b44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-2533.379,868.466V372.671h398.288V868.466",
    transform: "translate(3610.295 116)",
    fill: "#fff",
    stroke: "#4285f4",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87,0c65.729,0,87,7.611,87,17S135.049,34,87,34C8.416,34-37.863,26.389-37.863,17S21.271,0,87,0Z",
    transform: "translate(147 941)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103 648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1045.2,750.5l12.418-8.5,7.713,11.522L1029.48,897.55a3.288,3.288,0,0,1-4.231,2.326h0a3.288,3.288,0,0,1-2.211-3.614Z",
    transform: "translate(-995.334 -595.525)",
    fill: "#1b71c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.131,750.5,927.713,742,920,753.522,955.854,897.55a3.288,3.288,0,0,0,4.231,2.326h0a3.288,3.288,0,0,0,2.211-3.614Z",
    transform: "translate(-789.334 -595.525)",
    fill: "#1b71c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.754,750.5,911.336,742l-7.713,11.522L956.3,911.874a3.293,3.293,0,0,0,4.165,2.084h0a3.292,3.292,0,0,0,2.158-3.9Z",
    transform: "translate(-773.336 -595.525)",
    fill: "#509af7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.958,750.5l12.418-8.5,7.713,11.522-52.673,158.352a3.292,3.292,0,0,1-4.165,2.084h0a3.29,3.29,0,0,1-2.157-3.9Z",
    transform: "translate(-1012.089 -595.525)",
    fill: "#509af7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927,728s32-40,50-128c9-9,12,8,12,8l2,96-25,35Z",
    transform: "translate(-825 -595.525)",
    fill: "#e34730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.872,726S1029.127,710,951,733l125.872,9Z",
    transform: "translate(-940.872 -595.525)",
    fill: "#fdc500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.628,596c5-8,23,87-30,137h-125s14,27,141,20C1129.628,733,1088.628,606,1049.628,596Z",
    transform: "translate(-894.628 -595.525)",
    fill: "#f15b44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-2533.379,868.466l126.559-495.795H-2211.8V868.466",
    transform: "translate(2407 116)",
    fill: "#fff",
    stroke: "#4285f4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1962.213,801.327h119.95",
    transform: "translate(2407 -1)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1879.418,832.046V801.62",
    transform: "translate(2407 -1)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1947.878,832.046H-1809.5",
    transform: "translate(2407 -1)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1826.757,861.01V832.046",
    transform: "translate(2407 -1)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1720.787 780.327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1962.213,801.327h119.95",
    transform: "translate(1962.213 -741.645)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1879.418,801.62v30.426",
    transform: "translate(1962.213 -772.656)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1947.878,832.046H-1809.5",
    transform: "translate(1962.213 -803.083)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1826.757,832.046V861.01",
    transform: "translate(1962.213 -832.046)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1958.532,32V174.888",
    transform: "translate(2407 -32)",
    fill: "#4285f4",
    stroke: "#4285f4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 690,
    height: 7,
    transform: "translate(-126 133)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 690,
    height: 22,
    rx: 11,
    transform: "translate(-126 140)",
    fill: "#fdc600"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 33,
    transform: "translate(514 133)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1884.327,198V180.939h4.288V198",
    transform: "translate(2407 -32)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1884.327,198V180.939h4.288V198",
    transform: "translate(2426 -32)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1884.327,198V180.939h4.288V198",
    transform: "translate(2416.282 -32)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1884.327,198V180.939h4.288V198",
    transform: "translate(2435.282 -32)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1958.532,32V174.888",
    transform: "translate(2074.064 -32)",
    fill: "#4285f4",
    stroke: "#4285f4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 690,
    height: 7,
    transform: "translate(0 133)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 690,
    height: 22,
    rx: 11,
    transform: "translate(0 140)",
    fill: "#fdc600"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 33,
    transform: "translate(0 133)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.756 148.939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1880.039,198V180.939h-4.288V198",
    transform: "translate(1912.609 -180.939)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1880.039,198V180.939h-4.288V198",
    transform: "translate(1893.609 -180.939)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1880.039,198V180.939h-4.288V198",
    transform: "translate(1903.327 -180.939)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1880.039,198V180.939h-4.288V198",
    transform: "translate(1884.327 -180.939)",
    fill: "#cecece"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground9D63Cb4A);
export default __webpack_public_path__ + "static/media/background.9d63cb4a.9d63cb4a4b850d73c996477ad6904018.svg";
export { ForwardRef as ReactComponent };